module.exports = __webpack_public_path__ + "img/icon_7.0e2b3e9e.png";